import _asyncToGenerator from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.regexp.replace.js";

/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/
import '@quasar/extras/material-icons/material-icons.css'; // We load Quasar stylesheet file

import 'quasar/dist/quasar.sass'; // We add Quasar addons, if they were requested

import 'quasar/src/css/flex-addon.sass';
import 'src/css/app.sass';
import 'src/css/iconeye.css';
import 'src/css/fontawesome.css';
import Vue from 'vue';
import createApp from "./app.js";
import qboot_Bootconstants from 'boot/constants';
import qboot_Bootsentry from 'boot/sentry';
import qboot_Bootaxios from 'boot/axios';
import qboot_Bootgooglerecaptcha from 'boot/google-recaptcha';
import qboot_Bootkeyboard from 'boot/keyboard';
import qboot_Bootfilters from 'boot/filters';
import qboot_Bootecharts from 'boot/echarts';
import qboot_Boottree from 'boot/tree';
import qboot_Boothighcharts from 'boot/highcharts';
import qboot_Bootdialogs from 'boot/dialogs';
import qboot_Bootglobalmixins from 'boot/global-mixins';
import qboot_Bootwebsockets from 'boot/websockets';
import qboot_Bootcookies from 'boot/cookies';
import qboot_Boothubspot from 'boot/hubspot';
import qboot_Bootgtm from 'boot/gtm';
import qboot_Bootmeta from 'boot/meta';
import qboot_Bootmicrosoftteams from 'boot/microsoft-teams';
import qboot_Bootmicrosoftads from 'boot/microsoft-ads';
import qboot_Booteventhub from 'boot/event-hub';
import qboot_Bootrewardful from 'boot/rewardful';
import qboot_Bootoverlayscrollbars from 'boot/overlay-scrollbars';
import qboot_Bootcanny from 'boot/canny';
import qboot_Booti18n from 'boot/i18n';
import { addPreFetchHooks } from "./client-prefetch.js";

function start() {
  return _start.apply(this, arguments);
}

function _start() {
  _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$createApp, app, store, router, routeUnchanged, redirect, urlPath, bootFiles, i;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return createApp();

          case 2:
            _yield$createApp = _context.sent;
            app = _yield$createApp.app;
            store = _yield$createApp.store;
            router = _yield$createApp.router;
            routeUnchanged = true;

            redirect = function redirect(url) {
              routeUnchanged = false;
              window.location.href = url;
            };

            urlPath = window.location.href.replace(window.location.origin, '');
            bootFiles = [qboot_Bootconstants, qboot_Bootsentry, qboot_Bootaxios, qboot_Bootgooglerecaptcha, qboot_Bootkeyboard, qboot_Bootfilters, qboot_Bootecharts, qboot_Boottree, qboot_Boothighcharts, qboot_Bootdialogs, qboot_Bootglobalmixins, qboot_Bootwebsockets, qboot_Bootcookies, qboot_Boothubspot, qboot_Bootgtm, qboot_Bootmeta, qboot_Bootmicrosoftteams, qboot_Bootmicrosoftads, qboot_Booteventhub, qboot_Bootrewardful, qboot_Bootoverlayscrollbars, qboot_Bootcanny, qboot_Booti18n];
            i = 0;

          case 11:
            if (!(routeUnchanged === true && i < bootFiles.length)) {
              _context.next = 29;
              break;
            }

            if (!(typeof bootFiles[i] !== 'function')) {
              _context.next = 14;
              break;
            }

            return _context.abrupt("continue", 26);

          case 14:
            _context.prev = 14;
            _context.next = 17;
            return bootFiles[i]({
              app: app,
              router: router,
              store: store,
              Vue: Vue,
              ssrContext: null,
              redirect: redirect,
              urlPath: urlPath
            });

          case 17:
            _context.next = 26;
            break;

          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](14);

            if (!(_context.t0 && _context.t0.url)) {
              _context.next = 24;
              break;
            }

            window.location.href = _context.t0.url;
            return _context.abrupt("return");

          case 24:
            console.error('[Quasar] boot error:', _context.t0);
            return _context.abrupt("return");

          case 26:
            i++;
            _context.next = 11;
            break;

          case 29:
            if (!(routeUnchanged === false)) {
              _context.next = 31;
              break;
            }

            return _context.abrupt("return");

          case 31:
            addPreFetchHooks(router, store);
            new Vue(app);

          case 33:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[14, 19]]);
  }));
  return _start.apply(this, arguments);
}

start();